<div class="card border-radius-5">
  <div class="relative pt-3">
    <cp-widget-header
      text="Top tip"
      icon="light-bulb"
      variant="light"
      [isAbsolutePosition]="true" />
  </div>
  <div class="py-4">
    <div class="text-center px-5">
      <div class="text-28 bold-800">Create a new search and hit mortgage goals</div>
      <div class="pt-4">
        <video
          autoplay="true"
          [muted]="muted"
          style="height: 10rem"
          loop
          playsinline
          poster="/assets/images/dashboard-widget-poster-search.jpg"
          disablePictureInPicture>
          <source src="/assets/videos/search.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      <div class="pt-3 text-14">
        Explore your mortgage options and find the right deal for you with ongoing tracking and
        alerts keep you informed.
      </div>

      <div class="pt-3 text-center">
        <button pButton class="p-button centered p-button-primary m-a" (click)="openSmartSearch()">
          Create new mortgage search
        </button>
      </div>
    </div>
  </div>
</div>
